module.exports = __webpack_public_path__ + "static/media/Rectangle 12885.f305fff3.png";